import React, { useState, useEffect } from "react";
import Table from "../../../core/common/dataTable/index";
import { downloadInvoicePDF, getAllInvoices } from "../../../apis/financers";
import { formatDate } from "../../../environment";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";

type FinancerDataSet = {
  end_date: string;
  start_date: string;
  updatedAt: any;
  id: number;
  invoice_number: string;
  amount: number;
  createdAt: string;
  financer_id: number;
  financer: {
    id: number;
    full_name: string;
    email: string;
    phone_number: string;
    gst_number: string;
    company_name: string;
  };
  key?: number;
  EmpId?: string;
  Name?: string;
  Status?: string;
};

const FinancerData = () => {
  const [financerDataSet, setFinancerDataSet] = useState<FinancerDataSet[]>([]);
  const [total_amt, setTotalAmt] = useState();
  const getAllInvoice = async () => {
    try {
      const response = await getAllInvoices();
      if (response.status) {
        const formattedData = response.data.map(
          (item: FinancerDataSet, index: number) => ({
            ...item,
            key: item.id,
            EmpId: `#${index + 1}`,
            createdAt: formatDate(item.createdAt),
            updatedAt: formatDate(item.updatedAt),
            start_date: formatDate(item.start_date),
            end_date: formatDate(item.end_date),
            Name: item.financer?.full_name || "N/A",
            Status: "Active", // Set based on actual logic if needed
          })
        );
        setFinancerDataSet(formattedData);
        const totalAmount = response?.data?.reduce(
          (total: number, item: any) => total + item.amount,
          0
        );
        setTotalAmt(totalAmount);
      }
    } catch (error) {
      console.error("Failed to fetch invoices:", error);
    }
  };

  const handleDownload = async (id: number, invoiceNumber: string) => {
    try {
      const response = await downloadInvoicePDF(id);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${invoiceNumber}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  useEffect(() => {
    getAllInvoice();
  }, []);

  const columns = [
    {
      title: "Sr No",
      dataIndex: "EmpId",
      render: (text: string) => <span>{text}</span>,
      sorter: (a: FinancerDataSet, b: FinancerDataSet) =>
        parseInt(a.EmpId?.replace("#", "") || "0") -
        parseInt(b.EmpId?.replace("#", "") || "0"),
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (date: string) => <div>{date}</div>,
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (text: string) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{text}</p>
          </div>
        </div>
      ),
      sorter: (a: FinancerDataSet, b: FinancerDataSet) =>
        (a.Name || "").localeCompare(b.Name || ""),
    },
    {
      title: "Invoice No",
      dataIndex: "invoice_number",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (amount: number) => `₹ ${amount.toLocaleString()}`,
    },
    {
      title: "Actions",
      render: (_: any, record: FinancerDataSet) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => handleDownload(record.id, record.invoice_number)}
        >
          Download PDF
        </button>
      ),
    },
  ];

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(financerDataSet);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Financer Invoices");
    XLSX.writeFile(workbook, "Financers Invoices.xlsx");
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="card">
          <div className="card-body p-0">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              Financer Invoice Data
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  margin: "20px 0px 0px 6rem",
                }}
              >
                <div className="dropdown me-3">
                  <Link
                    style={{
                      background: "#3ab54bbf",
                      color: "#fff",
                    }}
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Export
                  </Link>

                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    {/* <li>
                        <div
                          onClick={exportToPDF}
                          className="btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </div>
                      </li> */}
                    <li>
                      <div
                        onClick={exportToExcel}
                        className=" btn  dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  margin: "20px 0px 0px 6rem",
                  color: "#fff",
                }}
              >
                Total Amount: ₹ {total_amt}
              </div>
            </div>

            <div>
              <Table
                dataSource={financerDataSet}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancerData;
